
import * as CryptoJS from 'crypto-js';
var cv = '';
function generateRandomString(length) {
  var text = '';
  let codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}
export const environment = {
  production: false,
  envName: 'qa',
  hostname:'qanew.ebom.toyota.com',
  authBucket:'access-auth',
  searchGridUrl:'https://qa.searchgrids.ebom.toyota.com/',
//redirectUrl: `https://login.microsoftonline.com/tmnatest.onmicrosoft.com/oauth2/authorize?client_id=0d47c5e2-e321-4225-a474-935e750c99b4&response_type=id_token&redirect_uri=https%3A%2F%2Fqa.ebom.toyota.com%2F&scope=openid&state=12345&nonce=678910`,
  redirectUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=0d47c5e2-e321-4225-a474-935e750c99b4&response_type=code&redirect_uri=https://qanew.ebom.toyota.com&response_mode=query&scope=openid&state=23343&code_challenge=',
  apiUrl: "http://localhost:8080/ebom",
  MastergridapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  MastersearchdropdownapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_1',
  Mastersearchdropdown1apiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  Mastersearchdropdown2apiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_1',
  Mastersearchdropdown3apiUrlrest1: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  Mastersearchdropdown3apiUrlrest2: 'https://api.qa.ebom.toyota.com/ebom_common_rest_3',
  BussinessgridapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_3',
  QualandExcpgridapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_3',
  QualandExcpgridapi1Url: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  BusinesssearchdropdownapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_3',
  Business_Qe_dropdownapiURL: 'https://api.qa.ebom.toyota.com/ebom_common_rest_1',
  Master_ActionapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_1',
  Master_EditapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_3',
  Master_ActionInsertApiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_1',
  // BusinessManAdjstapiUrl: 'https://6gr5m8y0u3.execute-api.us-east-1.amazonaws.com/dev/api',
  BussinessppsvapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  BusinessActionRestapiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  BusinessActionS2apiUrl: 'https://api.qa.ebom.toyota.com/ebom_common_rest_2',
  Uploadrest: ' https://api.qa.ebom.toyota.com/ebom_common_rest_3',
  NewURL : 'https://api.qa.ebom.toyota.com/qa_master_insert',
  region: 'us-west-2',
  uploadBucketName: 'ebom.fileupload',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  rmvUserDetailsUrl:'https://th4huac7nb.execute-api.us-west-2.amazonaws.com/dev/api/',
  tokenURL: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  grantType: 'authorization_code',
  clientId: '0d47c5e2-e321-4225-a474-935e750c99b4',
  redirectURI: 'https://qanew.ebom.toyota.com',
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv)
};

